import React, { useState, useEffect } from 'react';
import { PayListForOrdr } from 'graphql/order';
import { useQuery } from 'react-apollo';
import moment from 'moment';
import fmt from 'utils/fmt';
import { getReciptStr, convertEscapeStrToHtml } from 'utils/printer';

export default function OrderDetail(props) {
  // props.onClose
  // console.log(`OrderDetail props.ordrNo :: ${props.ordrNo}`);
  const { orderItem } = props;
  const ordrNo = orderItem.ordrNo;
  const [openPaymentIndex, setOpenPaymentIndex] = useState(null);

  const { data, refetch } = useQuery(PayListForOrdr, {
    variables: { ordrNo },
    fetchPolicy: 'no-cache',
  });

  const cancelPayPressed = async (payObj) => {
    try {
      const apiHost = process.env.REACT_APP_END_POINT.replace(/\/graphql$/, '');
      const response = await fetch(`https://${apiHost}/api/payment/cancelPayment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('token'),
        },
        body: JSON.stringify({
          orgTradeKey: payObj.payAprvNo,
          tid_time: moment(payObj.regDtm).format('YYYY-MM-DD HH:mm:ss'),
        }),
      });
      const result = await response.json();

      if (result.code !== '0000') {
        throw new Error(result.message || '결제취소에 실패했습니다.');
      }

      await refetch({ variables: { ordrNo } });
      props.refetchQueries();
    } catch (err) {
      console.error('결제취소 오류:', err);
      alert(err.message || '결제취소에 실패했습니다.');
    }
  };

  // console.log(`OrderDetail props :: ${JSON.stringify(props, null, 2)}`);

  const renderOrderDetails = (value, index) => {
    // console.log(value);
    const payInfo = value.pay;
    const userNick = value.order.userNick;
    const trDt = moment(payInfo.trDt, 'YYYYMMDD').format('YYYY-MM-DD');
    const trTm = moment(payInfo.trTm, 'HHmmss').format('HH:mm:ss');
    const halbuStr = payInfo.halbu === '00' ? '일시불' : payInfo.halbu;
    const payStts = value.pay.payStts;
    // payStts: "1:결제완료, 2:결제취소, 3:결제승인실패, 4:시스템실패,5:결제취소실패",
    // console.log(payStts);
    const isOpen = openPaymentIndex === index;

    return (
      <div key={`key-${index}`} className="border-b border-gray-500">
        <button
          type="button"
          className="flex w-full items-center justify-between p-4 text-left sm:hidden"
          onClick={() => setOpenPaymentIndex(isOpen ? null : index)}
          aria-expanded={isOpen}
        >
          <span className="min-w-0">
            <span className="block text-sm font-bold text-gray-900 truncate">결제취소 · {payInfo.payMethodDispNm}</span>
            <span className="block mt-1 text-sm text-primary">{fmt.getCurrency(payInfo.payAmt)}원</span>
          </span>
          <span className="ml-3 text-lg text-gray-700" aria-hidden="true">{isOpen ? '-' : '+'}</span>
        </button>
        <div className={`${isOpen ? 'block' : 'hidden'} p-4 pt-0 sm:flex sm:flex-row sm:items-center sm:justify-between sm:gap-3 sm:p-4`}>
          <div className="min-w-0 text-sm sm:text-base">
          <ul>
            <li>{payInfo.payMethodDispNm}</li>
          </ul>
          <ul>
            <li>고 객 명 : {userNick}</li>
          </ul>
          <ul>
            <li>카드금액 : {fmt.getCurrency(payInfo.payAmt)}</li>
          </ul>
          <ul>
            <li>승인번호 : {payInfo.authNum}</li>
          </ul>
          <ul>
            <li>발급매입 : {payInfo.msgOne}</li>
          </ul>
          <ul>
            <li>거래일자 : {trDt}</li>
          </ul>
          <ul>
            <li>거래시각 : {trTm}</li>
          </ul>
          <ul>
            <li>할 부 : {halbuStr}</li>
          </ul>
        </div>
        <div className="flex w-full justify-center mt-3 sm:w-auto sm:mt-0">
          <button
            className={`w-full h-12 font-bold text-white sm:w-24 sm:h-32 bg-${
              payStts === '1' ? 'alert' : 'cust-medium-gray'
            }`}
            onClick={async () => {
              if (payStts === '1') {
                const isConfirmed = window.confirm('정말 결제취소를 진행하시겠습니까?');
                if (isConfirmed) {
                  await cancelPayPressed(value.pay);
                }
              }
            }}>
            {payStts === '1' ? '결제취소' : '취소완료'}
          </button>
        </div>
      </div>
      </div>
    );
  };

  const ulStyle = 'flex flex-row justify-between px-4';
  const divider = (
    <ul className="flex justify-start items-center px-4">
      <li>-------------------------------------------------------</li>
    </ul>
  );

  const renderOptionItems = (value, index) => {
    return (
      <ul key={`ordr-opts-key-${index}`} className={ulStyle}>
        <li className="w-32 pl-3">- {value.ordrOptNm}</li>
        <li>{value.ordrOptQty}</li>
        <li>{fmt.getCurrency(value.ordrOptPrice)}</li>
      </ul>
    );
  };

  const renderOrderItems = (value, index) => {
    let optionGroupList;
    if (value.ordrOptGrps) {
      const ordrOptGrps = value.ordrOptGrps;
      if (ordrOptGrps && ordrOptGrps.length > 0) {
        ordrOptGrps.forEach((groupValue) => {
          optionGroupList = groupValue.ordrOptItems.map(renderOptionItems);
        });
        // ordrOptGrps.map((value, index) => {
        //   optionGroupList = value.ordrOptItems.map(renderOptionItems);
        // });
      }
    }

    return (
      <div key={`ordr-items-key-${index}`} className="flex flex-col">
        <ul className={ulStyle}>
          <li className="w-32">{value.ordrItemNm}</li>
          <li>{value.ordrItemQty}</li>
          <li>{fmt.getCurrency(value.menuPrice * value.ordrItemQty)}</li>
        </ul>
        {optionGroupList && optionGroupList}
      </div>
    );
  };

  const orderAt = moment(orderItem.ordrAt).format('YYYY-MM-DD HH:mm:ss');
  // const isPaid = payStts
  // console.log(orderItem);

  // if (orderItem && data && data.payListForOrdr) {
  //   let printStr = getReceiptStr(orderItem, data.payListForOrdr);
  //   console.log(printStr);
  // }
  const orderDetailStr = getReciptStr(orderItem);
  const orderDetailHtml = convertEscapeStrToHtml(orderDetailStr);
  // console.log(orderDetailStr);

  return (
    <div
      className="flex flex-col flex-1 min-h-0 bg-cust-gray overflow-hidden outline-none focus:outline-none"
    >
      <div className="flex flex-1 flex-col min-h-0 w-full overflow-y-auto md:flex-row">
        <div className="flex justify-center min-w-0 w-full p-3 overflow-x-auto md:w-1/2 md:p-4 md:border-r">
          <div
            className="max-w-full text-xs leading-relaxed break-all sm:text-sm md:max-w-none"
            dangerouslySetInnerHTML={{ __html: orderDetailHtml }}
          ></div>
        </div>
        {/* <div className="w-1/2 pt-4">
          <ul className={ulStyle}>
            <li>주문일시 {orderAt}</li>
            <li>[매장용]</li>
          </ul>
          <ul className={ulStyle}>
            <li>결제여부</li>
            <li>[결제완료]</li>
          </ul>
          {divider}
          <ul className={ulStyle}>
            <li>접수번호 : </li>
            <li>{orderItem.acceptNum}</li>
          </ul>
          <ul className={ulStyle}>
            <li>테이블</li>
            <li>#{orderItem.tblNm}</li>
          </ul>
          {divider}
          <ul className={ulStyle}>
            <li className="w-32">메뉴</li>
            <li>수량</li>
            <li>금액</li>
          </ul>
          {divider}
          {orderItem.ordrItems.map(renderOrderItems)}
          {divider}
          <ul className={ulStyle}>
            <li>주문합계</li>
            <li>{orderItem.payAmt}</li>
          </ul>
          <ul className="flex justify-start items-center px-4">
            <li>======================================</li>
          </ul>
        </div> */}
        <div className="hidden bg-white md:block md:w-1/2">{data && data.payListForOrdr.map(renderOrderDetails)}</div>
      </div>
      <div className="shrink-0 bg-white border-t border-gray-400 md:hidden">{data && data.payListForOrdr.map(renderOrderDetails)}</div>
      <div className="flex justify-center shrink-0 p-3 bg-cust-gray border-t border-cust-line sm:py-4">
        <button
          className="w-full h-12 font-bold text-white bg-primary sm:w-40 sm:h-16"
          onClick={() => {
            props.onClose();
          }}>
          확인
        </button>
      </div>
    </div>
  );
}
